export const state = {
  access_Token: "",
  user: JSON.parse(localStorage.getItem("user") || "{}"),
  navigation: JSON.parse(localStorage.getItem("nav-menu") || "[]"),
  formData: {
    username: null,
    password: null,
  },
};
